<template>
  <v-card flat>
    <v-card-title>Unificar productos</v-card-title>
    <v-card-text>
      <p class="mb-4">
        Los productos listados a continuación serán
        <strong>unificados en un único producto</strong>. El nuevo producto
        resultante conservará la información que se complete en el formulario de
        la derecha.xD
      </p>
      <v-row>
        <!-- Lista de productos seleccionados -->
        <v-col cols="12" md="6">
          <v-list-item-group v-model="selectedItem" color="primary">
            <v-list two-line>
              <v-subheader>Productos a unificar</v-subheader>
              <v-list-item
                v-for="producto in productosSeleccionados"
                :key="producto.id"
                @click="seleccionarProducto(producto)"
              >
                <v-list-item-avatar>
                  <v-img
                    src="require('@/assets/no-image.png')"
                  ></v-img>
                </v-list-item-avatar>
                <v-list-item-content>
                  <v-list-item-title>{{
                    producto.descripcion_comercial
                  }}</v-list-item-title>
                  <v-list-item-subtitle>
                    {{ producto.marca.nombre }}
                  </v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </v-list-item-group>
          <v-divider></v-divider>
        </v-col>

        <!-- Formulario del nuevo producto unificado -->
        <v-col cols="12" md="6">
          <v-form v-model="formValido" v-if="productoNuevo">
            <v-subheader>Datos generales del producto (catálogo)</v-subheader>

            <!-- Campo: descripción global (catálogo) -->
            <ProductoDescripcionForm
              :descripcion="productoNuevo.catalogo.descripcion_global"
              @update:descripcion="setDescripcionGlobal"
            />

            <!-- Campo: código de barra (catálogo) -->
            <ProductoBarcodeForm :producto="productoNuevo.catalogo" />

            <!-- Campo: marca (catálogo) -->
            <ProductoMarcaForm
              :outlined="true"
              :producto="productoNuevo.catalogo"
            />

            <v-divider class="my-4"></v-divider>
            <v-subheader>Datos específicos de tu empresa</v-subheader>

            <!-- Campo: nombre comercial (empresa) -->
            <ProductoDescripcionForm
              :descripcion="productoNuevo.empresa.descripcion"
              @update:descripcion="setDescripcion"
            />

            <!-- Campo: categoría (empresa) -->
            <ProductoCategoriaForm
              @set_categoria="setCategoria"
              :categoria="productoNuevo.empresa.categoria"
            />
          </v-form>
        </v-col>
      </v-row>
    </v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn
        outlined
        color="white"
        :disabled="!formValido"
        @click="unificarProductos"
      >
        Unificar
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import ProductoDescripcionForm from "@/components/producto/form/form.producto.descripcion.vue";
import ProductoMarcaForm from "@/components/producto/form/form.producto.marca.vue";
import ProductoCategoriaForm from "@/components/producto/form/form.producto.categoria.vue";
import ProductoBarcodeForm from "@/components/producto/form/form.producto.barcode.vue";

import ProductosAPI from "@/api/productos";

export default {
  name: "ProductosUnificar",
  components: {
    ProductoMarcaForm,
    ProductoDescripcionForm,
    ProductoCategoriaForm,
    ProductoBarcodeForm,
  },
  props: {
    productosSeleccionados: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      formValido: false,
      selectedItem: 0,
      productoNuevo: {
        catalogo: {
          descripcion_global: "",
          codigoDeBarra: null,
          marca: { id: null },
        },
        empresa: {
          id: null, // ID del producto empresa seleccionado
          descripcion: "",
          categoria: { id: null },
        },
      },
    };
  },
  methods: {
    setDescripcion(valor) {
      this.productoNuevo.empresa.descripcion = valor;
    },
    setDescripcionGlobal(valor) {
      this.productoNuevo.catalogo.descripcion_global = valor;
      // Si querés que se copie automáticamente al nombre comercial
      this.productoNuevo.empresa.descripcion = valor;
    },
    setCategoria(categoria) {
      this.productoNuevo.empresa.categoria = categoria;
    },
    seleccionarProducto(producto) {
      this.productoNuevo.catalogo.descripcion_global =
        producto.descripcion_global;
      this.productoNuevo.catalogo.marca = producto.marca;
      this.productoNuevo.catalogo.codigoDeBarra = producto.codigoDeBarra;

      this.productoNuevo.empresa.descripcion = producto.descripcion_comercial;
      this.productoNuevo.empresa.categoria = producto.categoria;
      this.productoNuevo.empresa.id = producto.id; // Guardamos el ID del producto empresa seleccionado
    },
    async unificarProductos() {
      try {
        const payload = {
          productos_ids: this.productosSeleccionados.map((p) => p.id), // IDs de los productos seleccionados para unificar
          nuevo_producto: {
            catalogo: this.productoNuevo.catalogo, // Datos del catálogo (globales)
            empresa: this.productoNuevo.empresa, // Datos de la empresa (locales)
          },
        };

        const response = await ProductosAPI.unificarProductos(payload);

        this.$emit("unificacionExitosa", response.data);

        this.$updateBus.$emit("showSnackBar", {
          show: true,
          button: false,
          color: "success",
          text: "Productos unificados",
          icon: "mdi-check",
          timeout: 3000,
        });
      } catch (error) {
        console.error(error);
        this.$updateBus.$emit("showSnackBar", {
          show: true,
          button: false,
          color: "info",
          text: `${error.response.data.detail}`,
          icon: "mdi-information",
          timeout: 3000,
        });
      }
    },
  },
  watch: {
    productosSeleccionados: {
      immediate: true,
      deep: true,
      handler(value) {
        const producto = value[0];
        if (producto) {
          this.productoNuevo.catalogo.descripcion_global =
            producto.descripcion_global;
          this.productoNuevo.catalogo.marca = producto.marca;
          this.productoNuevo.catalogo.codigoDeBarra = producto.codigoDeBarra;

          this.productoNuevo.empresa.descripcion =
            producto.descripcion_comercial;
          this.productoNuevo.empresa.categoria = producto.categoria;
          this.productoNuevo.empresa.id = producto.id;
        }
      },
    },
  },
};
</script>
